import { render } from "./DefaultLayout.vue?vue&type=template&id=a262fcbe"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=a262fcbe&lang=css"

import exportComponent from "../../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__